import { createRoot } from 'react-dom/client';

import Root from './root.component';

createRoot(document.getElementById('root')!).render(<Root />);
